import { Navigate } from "react-router-dom";
import JobTypeList from "../components/jobTypeList";
import JobTypeCreate from "../components/jobTypeCreate";
import JobTypeEdit from "../components/jobTypeEdit";
import SvgIcons from "../../../../shared/components/svgIcons";

const userRoute = {
  icon: SvgIcons.MasterDataIcon,
  name: "Master Data",
  link: "/master-datas",
  path: "/master-datas",
  element: "",
  index: 220,
  children: [
    {
      path: "job-types",
      element: <JobTypeList />,
      name: "Job Types",
      permission: "Job Type",
      index: 5,
      link: "master-datas/job-types",
      icon: SvgIcons.JobTypesIcon,
    },
    {
      path: "job-types/create",
      element: <JobTypeCreate />,
    },
    {
      path: "job-types/:id",
      element: <JobTypeEdit />,
    },
    {
      path: "",
      element: <Navigate to="master-datas/job-types" replace />,
    },
  ],
};
export default userRoute;
